<template>
  <div>
    <table :id="id" class="table table-striped table-bordered w-100" :style="'font-size: '+this.dtFontSize+'px;'">
      <thead>
        <tr>
          <th v-for="(columna, k) in columnas" :key="k">
            <i :class="columna.clase"></i> {{ columna.nombre }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(columna, k) in datos" :key="k">
          <td v-for="(dato, j) in columna" :key="j">
            <span>{{ dato }}</span>
          </td>
          <slot v-bind:button="columna" v-if="columnDetalles">
              <!-- <a :href="'errores-integraciones/'+columna[0]" class="btn btn-primary">Ver</a> -->
              <button class="btn btn-primary" @click="$emit('test',columna[0])">Ver</button>
          </slot>
          
        </tr>
      </tbody>
       
    </table>
  </div>
</template>
<script>
const language_tables = "/inspinia/plugins/DataTables/i18n/Spanish.json"
export default {
  props: ['id', 'datos', 'columnas', 'responsive', 'fontSize'],
  data: function() {
    return {
      dtFontSize: 11,
      columnDetalles: false
    };
  },
  mounted() {
    this.boton();

    this.dtFontSize = this.fontSize ?? 11;
    $(`#${this.id}`).DataTable({
      destroy: true,
      responsive: this.responsive ?? true,
      language: { url: language_tables },
      dom:
        '<"row"<"col-sm-5"B><"col-sm-7"lf>>t<"row"<"col-sm-5"i><"col-sm-7"p>>',
      buttons: [
        {
          extend: "colvis",
          className: "btn-sm btn-gray",
          text: '<i class="fa fa-filter"></i> Columnas visibles',
        },
        {
          extend: "excel",
          className: "btn-sm btn-gray",
          text: '<i class="fa fa-file-excel"></i> Excel',
          exportOptions: {
            columns: ":not(.notexport)",
          },
        },
        {
          extend: "pdf",
          className: "btn-sm btn-gray",
          text: '<i class="fa fa-file-pdf"></i> PDF',
          orientation: "landscape",
          exportOptions: {
            columns: ":not(.notexport)",
          },
        },
      ],
      order: [],
    });
   
  },
  destroyed() {
    $(`#${this.id}`).DataTable().clear().destroy()
  },
  methods: {
    boton(){
      // console.log(this.columnas);
       let x = this.columnas.find((element)=>{return element.nombre == "Detalles"});
      //  console.log(x);
        if(x){
          this.columnDetalles = true
        }
      // console.log(x);/
    }
  },
}
</script>
<style>
.dataTables_filter label {
    margin-right: 0px !important;
}
</style>